import * as Dialog from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { useLocation , useNavigate } from 'react-router-dom';
// import ExportEmail from './ExportEmail';
import { useEmailContext } from 'features/email-generator/EmailGeneratorContext';

const GoBack = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { updateEmailContent, setFormState, isPanelOpen, setIsPanelOpen } =
    useEmailContext();

  // Handle back button click
  const handleBackClick = () => {
    // If edit panel is open, close it instead of showing the dialog
    if (isPanelOpen) {
      setIsPanelOpen(false);
    } else {
      // If not in edit mode, show the dialog
      setOpen(true);
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <div
          className={`w-8 h-8 items-center cursor-pointer ${location.pathname === '/email-generator/email' ? 'flex' : 'hidden'}`}
          onClick={handleBackClick}
        >
          <ArrowLeft size={16} className="text-primary" />
        </div>
      </Dialog.Trigger>
      <Dialog.Overlay className="fixed inset-0 bg-background-overlay/50" />
      <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg bg-background-main p-5 z-50 w-[95%] max-w-[450px] mx-auto">
        <Dialog.Title className="text-xl md:text-2xl text-left font-bold text-text-primary">
          Go back?
        </Dialog.Title>
        <Dialog.Description className="text-text-primary/80 w-full mt-2 text-left text-[14px] md:text-[15px] font-normal">
          Are you sure you want to go back without exporting the email? It will
          be discarded if you do so.
        </Dialog.Description>
        <div className="flex justify-end sm:flex-row mt-6 gap-2">
          <Button
            variant="customSecondary"
            onClick={() => setOpen(false)}
            className="text-[14px] bg-secondary text-primary w-full sm:w-auto"
          >
            Cancel
          </Button>

          <Button
            variant="customSecondary"
            className="text-[14px] bg-secondary text-primary w-full sm:w-auto"
            onClick={() => {
              navigate('/email-generator/get-started');
              setFormState({
                tone: '',
                type: '',
                prompt: '',
                language: '',
                drafts: 1,
              });
              updateEmailContent([]);
            }}
          >
            Continue
          </Button>

          {/* <ExportEmail /> */}
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default GoBack;
